import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
import { DONGLE_FUN_TYPE, tableDataSchemas } from '../config';
import { indexMethod } from '@/utils/indexMethod';
export default {
  __name: 'Table',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 8
    }
  },
  emits: ['del', 'data', 'update', 'info'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const handleUpdate = row => {
      emits('update', row);
    };
    const handleDel = row => {
      emits('del', row);
    };
    const handleInfo = row => {
      emits('info', row);
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.tableData,
        style: {
          "width": "100%"
        },
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          type: "index",
          index: index => _unref(indexMethod)(index, __props.currentPage, __props.pageSize),
          align: "center",
          "min-width": 30
        }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableDataSchemas), (item, index) => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            label: item.label,
            "min-width": item.minWidth,
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [item.prop === 'dongleFunType' ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(DONGLE_FUN_TYPE)[row[item.prop]]), 1)) : item.prop === 'createTime' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$filters.dateFilter(row[item.prop])), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(row[item.prop]), 1))]),
            _: 2
          }, 1032, ["label", "min-width"]);
        }), 128)), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "330",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "success",
            size: "small",
            onClick: $event => handleInfo(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 详情 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => handleUpdate(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "danger",
            size: "small",
            onClick: $event => handleDel(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]]);
    };
  }
};